import { z } from 'zod';
import useTranslation from 'next-translate/useTranslation';

const useWithdrawalSchema = () => {
  const { t } = useTranslation('payments');

  return z
    .object({
      withdrawalAmount: z.number({
        required_error: t('withdrawal.form.amount.error'),
        invalid_type_error: t('withdrawal.form.amount.error'),
      }),
    })
    .strict();
};

export default useWithdrawalSchema;
